import { render } from "./daythree.vue?vue&type=template&id=05312991"
import script from "./daythree.vue?vue&type=script&lang=js"
export * from "./daythree.vue?vue&type=script&lang=js"

import "./daythree.vue?vue&type=style&index=0&id=05312991&lang=scss"
script.render = render

export default script